var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCustomersIcon = function SvgCustomersIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.917 3.438a2.813 2.813 0 1 0 0 5.625 2.813 2.813 0 0 0 0-5.626ZM3.23 6.25a4.687 4.687 0 1 1 9.375 0 4.687 4.687 0 0 1-9.375 0Zm9.264-3.777a.937.937 0 0 1 1.257-.423 4.688 4.688 0 0 1 0 8.4.937.937 0 1 1-.835-1.68 2.813 2.813 0 0 0 0-5.04.937.937 0 0 1-.422-1.257ZM7.917 14.27c-2.077 0-4.027 1.084-5.513 2.975A.938.938 0 0 1 .93 16.087c1.758-2.237 4.213-3.691 6.987-3.691s5.229 1.454 6.987 3.691a.937.937 0 1 1-1.474 1.159c-1.486-1.891-3.436-2.975-5.513-2.975Zm6.23-.686a.938.938 0 0 1 1.24-.467c1.415.64 2.665 1.672 3.684 2.97a.937.937 0 1 1-1.475 1.158c-.86-1.095-1.879-1.92-2.982-2.42a.937.937 0 0 1-.468-1.24Z",
    fill: "currentColor"
  })));
};

export default SvgCustomersIcon;